import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { DEFAULT_BRAND_LINES } from '@cortex/mall-scoring';
import { Card } from '../../components/ui/Card';

/**
 * @graph-node {Page}
 * @graph-stack mall
 * @graph-domain Operations
 * @graph-business ブランドラインマスタ一覧ページ。本番DB実績データ（DEFAULT_BRAND_LINES）をテーブル表示（読み取り専用）
 * @graph-connects none
 */
export const Route = createFileRoute('/master/brand-lines')({
  component: BrandLinesPage,
});

/** @graph-connects none */
function BrandLinesPage() {
  const { t } = useTranslation();
  const entries = Object.entries(DEFAULT_BRAND_LINES);

  return (
    <Card variant="glass" className="animate-fade-in">
      <div className="mb-4 p-3 rounded-lg bg-[var(--color-info-muted)] border border-[var(--color-info)]/20">
        <span className="text-sm text-[var(--color-text-secondary)]">
          {t('master.productionDataNote')}
        </span>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-[var(--color-text-muted)] text-xs border-b border-[var(--color-border)]">
              <th className="text-left py-3 pr-4">{t('master.lineKey')}</th>
              <th className="text-right py-3 px-4">{t('master.rate')}</th>
              <th className="text-right py-3 px-4">{t('master.rentals')}</th>
              <th className="text-right py-3 pl-4">{t('master.avgDays')}</th>
            </tr>
          </thead>
          <tbody>
            {entries.map(([key, line]) => (
              <tr key={key} className="border-b border-[var(--color-border)] last:border-b-0">
                <td className="py-2.5 pr-4 font-mono text-[var(--color-text-primary)]">{key}</td>
                <td className="py-2.5 px-4 text-right font-mono text-[var(--color-text-secondary)]">
                  {line.rate.toFixed(1)}%
                </td>
                <td className="py-2.5 px-4 text-right font-mono text-[var(--color-text-secondary)]">
                  {line.rentals}
                </td>
                <td className="py-2.5 pl-4 text-right font-mono text-[var(--color-text-secondary)]">
                  {line.avgDays.toFixed(1)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
